import './styles.scss';

import Button from '@/common/Button';
import DrawerBody from '@/common/Drawer/DrawerBody';
import DrawerHeader from '@/common/Drawer/DrawerHeader';
import { DrawerTypes } from '@/common/Drawer/types';
import { Offcanvas } from 'react-bootstrap';
import { ReactElement } from 'react';
import { getClasses } from '@/utils';

const Drawer = ({ title, icon, content: Content, header: Header, children, ...offCanvasProps }: DrawerTypes.Props): ReactElement => {
  const adaptedProps = adaptProps({ ...offCanvasProps });
  return (
    <Offcanvas
      placement="end"
      {...adaptedProps}
      className={getClasses('Drawer', adaptedProps.className)}
      backdropClassName={getClasses('Drawer-Backdrop', adaptedProps.backdropClassName)}
    >
      <Button className="CloseButton Drawer-Close" variant="icon" onClick={adaptedProps.onHide}>
        <i className="sv sv-cross" />
      </Button>
      {Content && <Content />}
      <DrawerHeader title={title} icon={icon}>
        {Header && <Header />}
      </DrawerHeader>
      <DrawerBody>{children}</DrawerBody>
    </Offcanvas>
  );
};

function adaptProps(props: DrawerTypes.Props): DrawerTypes.BaseProps {
  return (Object.keys(props) as Array<keyof DrawerTypes.Props>).reduce<DrawerTypes.BaseProps>((acc, key) => {
    const adaptor = {
      placement: {
        top: 'top',
        bottom: 'bottom',
        left: 'start',
        right: 'end',
      },
    };
    acc[key] = adaptor?.[key]?.[props?.[key]] || props?.[key];
    return acc;
  }, {} as DrawerTypes.BaseProps);
}

export default Drawer;
